import { useCallback, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";
import { uplodateLoading } from "../../../redux/features/common/commonSlice";

export const TransferToPromoModal = (props) => {
    const dispatch = useDispatch()
    const [categoryDropdown, setCategoryDropdown] = useState(null);
    const [languageDropdown, setLanguageDropdown] = useState(null);
    const userData = useSelector((state) => state?.userData);
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    });
    const optionPageNumberRef = useRef(pagerecord.pageNumber);
    const languagePageNumberRef = useRef(pagerecord.pageNumber);

    const wrappedLoadOptions = useCallback(function (...args) {
        return loadOptionsTest(...args);
    }, []);

    const sleep = (ms) =>
        new Promise((resolve) => {
            setTimeout(() => {
                resolve(undefined);
            }, ms);
        });

    const loadOptionsTest = async (
        search,
        prevOptions
    ) => {
        console.log("1")
        await sleep(1000);
        try {
            let postJson = {
                searchText: search?.trim(),
                pageNumber: search?.trim() ? 0 : optionPageNumberRef.current - 1 || 0,
                pageSize: pagerecord.pageSize || 10,
                shortingField: "createdAt",
                asc: false
            };

            let path = urls.tagInterestList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                console.log(response?.data?.response?.items)
                let tempArray = []
                response?.data?.response?.items.forEach(element => {
                    tempArray.push({
                        value: element?.id,
                        label: element?.name
                    })
                });
                setPagerecord({
                    ...pagerecord,
                    pageNumber: pagerecord?.pageNumber + 1
                })
                optionPageNumberRef.current = optionPageNumberRef.current + 1;
                const hasMore = response?.data?.response?.totalPages > 0 && response?.data?.response?.totalPages > pagerecord?.pageNumber;
                return {
                    options: tempArray,
                    hasMore
                };

            } else {
                showDangerToast(response.message)
            }
        } catch (error) {
            console.error(error)
            showDangerToast(error.message)
        }

    };

    const handleTransferToPromo = async () => {
        let postData = {
            categoryId: categoryDropdown?.value,
            languageId: languageDropdown?.value,
            link: props?.link,
            fileName: props?.link
        }
        dispatch(uplodateLoading(true))
        try {
            let path = urls.addPromoVideo
            var resBlog = await ApiCaller.post(postData, path, userData?.access_token)
            const responseBlog = await resBlog.response.json()
            if (responseBlog.status == 200) {
                dispatch(uplodateLoading(false))
                showToast(responseBlog?.message)
                props?.onSubmit()
            } else {
                dispatch(uplodateLoading(false))
                showDangerToast(responseBlog.message)
            }
        } catch (error) {
            dispatch(uplodateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }


    const langualgeSleep = (ms) =>
        new Promise((resolve) => {
            setTimeout(() => {
                resolve(undefined);
            }, ms);
        });

    const languageWrappedLoadOptions = useCallback(function (...args) {
        return loadLanguageOptions(...args);
    }, []);

    const loadLanguageOptions = async (
        search,
        prevOptions
    ) => {
        console.log("1")
        await langualgeSleep(1000);
        try {
            let postJson = {
                searchText: search?.trim(),
                pageNumber: search?.trim() ? 0 : languagePageNumberRef.current - 1 || 0,
                pageSize: pagerecord.pageSize || 10,
                shortingField: "createdAt",
                asc: false
            };

            let path = urls.languageList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                console.log(response?.data?.response?.items)
                let tempArray = []
                response?.data?.response?.items.forEach(element => {
                    tempArray.push({
                        value: element?.id,
                        label: element?.name
                    })
                });
                setPagerecord({
                    ...pagerecord,
                    pageNumber: pagerecord?.pageNumber + 1
                });
                languagePageNumberRef.current = languagePageNumberRef.current + 1;
                const hasMore = response?.data?.response?.totalPages > 0 && response?.data?.response?.totalPages > pagerecord?.pageNumber;
                return {
                    options: tempArray,
                    hasMore
                };

            } else {
                showDangerToast(response.message)
            }
        } catch (error) {
            console.error(error)
            showDangerToast(error.message)
        }

    };


    return <>
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Select Language And Category For Promo
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-6'>
                        <AsyncPaginate
                            debounceTimeout={300}
                            value={categoryDropdown}
                            placeholder="Select Category" // Custom placeholder text
                            // loadOptions={loadOptions}
                            loadOptions={wrappedLoadOptions}
                            onChange={(e) => {
                                setCategoryDropdown(e)
                                console.log(e)
                                // setFilterData((pre) => ({ ...pre, searchText: e?.label }))
                            }}
                        />
                    </div>
                    <div className='col-md-6'>
                        <AsyncPaginate
                            debounceTimeout={300}
                            value={languageDropdown}
                            placeholder="Select Language" // Custom placeholder text
                            // loadOptions={loadOptions}
                            loadOptions={languageWrappedLoadOptions}
                            onChange={(e) => {
                                setLanguageDropdown(e)
                                console.log(e)
                                // setFilterData((pre) => ({ ...pre, searchText: e?.label }))
                            }}
                        />
                    </div>
                </div>


            </Modal.Body>
            <Modal.Footer>
                <Button variant="outlined" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button onClick={() => handleTransferToPromo()}>Submit</Button>
            </Modal.Footer>
        </Modal>
    </>
}